import { QwickLogo } from "@gigpro/ui/Icons";
import { useLoaderOption } from "./useLoaderOption";

export const LoaderLogo = () => {
  const [, message] = useLoaderOption();

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center">
      <QwickLogo className="h-auto max-h-40 w-[45vw] max-w-72 animate-size-pulse text-black sm:w-[26vw] md:w-[22vw] lg:w-[22vw] xl:w-[15vw]" />
      <p className="mt-4 animate-size-pulse text-large xl:mt-6">{message}</p>
    </div>
  );
};
